import React from "react";
import { Form } from "react-bootstrap";
import { _t } from "../../../../../app/i18n/i18n";
import useCookie from "react-use-cookie";
import { useDispatch, useSelector } from "react-redux";
import { filterReducer } from "pages/search/api/filterReducer";
import { removeParam, push } from "pages/search/api/filterUrlMaker";

export const OrderByDropdown = () => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter);
  let [sort, setSortCookie] = useCookie("grp-sort", "");
  const setSort = (sort) => {
    dispatch(filterReducer.actions.setSort(sort));
    setSortCookie(sort, { days: 365, path: "/" });
    push(removeParam("sort"));
  };

  if (filter.qs.sort) {
    sort = filter.qs.sort;
  }

  return (
    <Form.Control
      as="select"
      size="sm"
      className="d-inline w-auto"
      onChange={(e) => setSort(e.target.value)}
      defaultValue={sort}
    >
      <option value="Publicationdate_Desc">{_t("Order by date (newest)")}</option>
      <option value="Publicationdate_Asc">{_t("Order by date (oldest)")}</option>
      <option value="Pagecount_Desc">{_t("Order by pages (most)")}</option>
      <option value="Pagecount_Asc">{_t("Order by pages (fewest)")}</option>
      {/* <option>{_t("By relevance")}</option> */}
      <option value="ReadCount_Desc">{_t("Order by popularity")}</option>
      {/* <option>{_t("Top stories")}</option> */}
    </Form.Control>
  );
};
